import React, { Component } from 'react';
import { Route, withRouter } from "react-router-dom";
import SimplePopover from '../SimplePopover';

import AdaptativaHeader from '../AdaptativaHeader';
import Simulado from './simulado/Simulado';
import Acompanhamento from './acompanhamento/Acompanhamento';
import BibliotecaConteudo from '../shared/conteudo/BibliotecaConteudo';
import CorrecaoAtividades from './correcao/CorrecaoAtividades';
import Configuracoes from './Configuracoes';
import FloatingVideo from '../FloatingVideo';

class CoordenadorPage extends Component {

    getActiveTab(defaultRoute) {
        var path = (defaultRoute || this.props.location.pathname).toLowerCase();

        if (path === "/app/acompanhamento") { return { title: "Acompanhamento", backgroundClassName: " adap-yellow ", borderClassName: " adap-border-yellow " }; }
        if (path === "/app/simulado") { return { title: "Simulados", backgroundClassName: " adap-red ", borderClassName: " adap-border-red " }; }
        if (path === "/app/biblioteca") { return { title: "Biblioteca de Conteúdo", backgroundClassName: " adap-blue ", borderClassName: "  adap-border-blue " }; }
        if (path === "/app/correcao") { return { title: "Correção de atividades", backgroundClassName: " adap-green ", borderClassName: " adap-border-green " }; }
        if (path === "/app/config") { return { title: "Configurações", backgroundClassName: " adap-dark-gray ", borderClassName: " adap-border-dark-gray " }; }

        //Se não está em nenhuma das rotas anteriores, retorna a aba padrão
        return this.getActiveTab("/app/simulado");
    }

    aba_open() {
        console.log('document.getElementById("mnuAdaptativa").style.display',document.getElementById("mnuAdaptativa").style.display)
        if(document.getElementById("mnuAdaptativa").style.display === "" || document.getElementById("mnuAdaptativa").style.display === "none") {
            document.getElementById("mnuAdaptativa").style.display = "block";
        }
        else {
            document.getElementById("mnuAdaptativa").style.display = "none";
        }
    }

    aba_close() {
        document.getElementById("mnuAdaptativa").style.display = "none";
    }

    render() {
        return (
            <div >
                <AdaptativaHeader />

                {/* Navegação das Abas Dektop */}
                <div className={"edb-hide-small edb-hide-medium edb-margin-top edb-bottombar-small " + this.getActiveTab().borderClassName}>
                    <a className="edb-btn adap-yellow" href="#/app/acompanhamento">&nbsp;Acompanhamento&nbsp;</a>
                    <a className="edb-btn adap-red" href="#/app/simulado">&nbsp;Simulados&nbsp;</a>
                    <a className="edb-btn adap-blue" href="#/app/biblioteca">&nbsp;Biblioteca de Conteúdo&nbsp;</a>
                    <a className="edb-btn adap-green" href="#/app/correcao">&nbsp;Correção de atividades&nbsp;</a>
                    <a className="edb-right edb-padding" href="#/app/config"><i className="edb-xlarge fas fa-cog"></i></a>
                    <a className="edb-right edb-padding" title="Acesso à wiki.Adaptativa+" target="_blank" rel="noopener noreferrer" href={process.env.REACT_APP_WIKI+'/p/'}><i className="edb-xlarge fas fa-question-circle"></i></a>
                </div>

                {/* Navegação das Abas Mobile */}
                <div className={"edb-hide-large edb-hide-large edb-center" + this.getActiveTab().backgroundClassName}>

                    <SimplePopover droppdownId="mnuAdaptativa" noPadding={true} content={<div className="edb-bar-block" style={{ width: "300px" }}>
                        <a className="edb-bar-item edb-button edb-medium " onClick={this.aba_close} href="#/app/acompanhamento">&nbsp;Acompanhamento&nbsp;</a>
                        <a className="edb-bar-item edb-button edb-medium " onClick={this.aba_close} href="#/app/simulado">&nbsp;Simulados&nbsp;</a>
                        <a className="edb-bar-item edb-button edb-medium " onClick={this.aba_close} href="#/app/biblioteca">&nbsp;Biblioteca de Conteúdo&nbsp;</a>
                        <a className="edb-bar-item edb-button edb-medium " onClick={this.aba_close} href="#/app/correcao">&nbsp;Correção de atividades&nbsp;</a>
                        <a className="edb-bar-item edb-button edb-medium" target="_blank" rel="noopener noreferrer" href={process.env.REACT_APP_WIKI+'/p/'}>wiki.Adaptativa+</a>
                        <a className="edb-bar-item edb-button edb-medium" onClick={this.aba_close} href="#/app/config">Configurações</a>
                    </div>}>
                        <div onClick={this.aba_open} className="edb-btn" style={{ width: "300px" }}>
                            <span className="edb-large edb-text-bold adap-text-white">{this.getActiveTab().title}</span>
                            <i className="fas fa-chevron-down edb-margin-left adap-text-white"></i>
                        </div>
                    </SimplePopover>
                </div>

                <div className="adap-mobile-container">

                    {/* Aba padrão */}
                    <Route exact path="/app" component={Simulado} />

                    {/* Abas */}
                    <Route path="/app/simulado" component={Simulado} />
                    <Route path="/app/acompanhamento" component={Acompanhamento} />
                    <Route path="/app/config" component={Configuracoes} />
                    <Route path="/app/biblioteca" render={_ => <BibliotecaConteudo isCoordenador/>} />
                    <Route path="/app/correcao" component={CorrecaoAtividades} />

                    {false && this.getActiveTab().title==='Simulados' && <FloatingVideo
                        title="Veja o video explicativo"
                        source="https://player.vimeo.com/video/325981226"
                        />}
                </div>
            </div>
        );
    }
}

export default withRouter(props => <CoordenadorPage {...props} />);